export const GET_RECIPE_PREP_CYCLE_MENUS_LOADING =
  'GET_RECIPE_PREP_CYCLE_MENUS';
export const GET_RECIPE_PREP_CYCLE_MENUS_SUCCESS =
  'GET_RECIPE_PREP_CYCLE_MENUS_SUCCESS';
export const GET_RECIPE_PREP_CYCLE_MENUS_ERROR =
  'GET_RECIPE_PREP_CYCLE_MENUS_ERROR';

export const RECIPE_PREP_RESET_ERROR = 'RECIPE_PREP_RESET_ERROR';



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/state/types.js